import {EndpointValue, SettingParam} from "@/types/node";
import {Input} from "@/components/ui/input";
import {useEffect, useState} from "react";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import {apiMethods, httpModeColors} from "@/constants/apiMethods";
import {useValidation} from "@/utils/validation";

export const SettingEndpoint = ({
  param,
  handleChange,
  selectedNodeId,
  disabled = false,
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: EndpointValue) => void;
  selectedNodeId: string;
  disabled: boolean;
}) => {
  const [value, setValue] = useState<EndpointValue>({
    url: (param.value as EndpointValue)?.url || "",
    http_method:
      (param.value as EndpointValue)?.http_method || apiMethods[0].name,
  });

  // Use shared validation utility
  const {error, validate} = useValidation(param.validationSchema as any);

  useEffect(() => {
    if (param.value !== value) {
      setValue(param.value as EndpointValue);
    }
  }, [param, selectedNodeId]);

  return (
    <div className="mb-4 w-full">
      {param.label && (
        <label className="text-sm font-medium text-label mb-2 flex items-center justify-between">
          {param.label}
        </label>
      )}
      <div className="flex gap-2 items-start">
        <Select
          onValueChange={http_method => {
            const newValue = {...value, http_method};
            setValue(newValue);
            validate(newValue);
            handleChange(param, newValue);
          }}
          value={value.http_method}
          disabled={disabled}
        >
          <SelectTrigger
            className={`w-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
              disabled ? "pointer-events-none" : ""
            }`}
          >
            <div
              className={`${httpModeColors[value.http_method]} text-sm font-medium px-1.5 py-1 rounded-md`}
            >
              {value.http_method?.toUpperCase() || param.placeholder}
            </div>
          </SelectTrigger>
          <SelectContent>
            {apiMethods.map(method => (
              <SelectItem value={method.name} key={method.name}>
                <div className="flex items-center gap-2">
                  <div
                    className={`${httpModeColors[method.name]} w-16 text-center text-sm font-medium px-1.5 py-1 rounded-md`}
                  >
                    {method.name.toUpperCase()}
                  </div>
                  <span className="text-label text-sm">{method.text}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          containerClassName="flex-grow"
          className={`focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:bg-muted`}
          onChange={e => {
            const newValue = {...value, url: e.target.value};
            validate(newValue);
            setValue(newValue);
            handleChange(param, newValue);
          }}
          value={value.url}
          placeholder={param.placeholder}
          disabled={disabled}
          error={error}
        />
      </div>
    </div>
  );
};
